<template>
  <div
    v-show="loading"
    class="wrapper"
    @touchmove.prevent>
    <sf-loading/>
    <div class="text">{{ $t('layout.loading-text') }}</div>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
  }),
  methods: {
    start() {
      this.loading = true;
    },
    finish() {
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  @extend %overlay;
  @extend %centered;
  position: fixed;
  flex-direction: column;
  z-index: 100;
  background: rgba(255, 255, 255, 0.7);
}

.text {
  font-weight: 600;
  font-size: 20px;
}
</style>
